import { useTranslation } from 'react-i18next';

const DEVICE_IMGS = [
  'https://onetvservices.me/smart-tv-CBz9Egjz.png',
  'https://onetvservices.me/android-tv-CbPMa0r9.png',
  'https://onetvservices.me/fire-stick-Z_BMWC7H.png',
  'https://onetvservices.me/smartphone-DvtjjDcf.png',
  'https://onetvservices.me/tablet-B1O-fevH.png',
  'https://onetvservices.me/laptop-D1CsEkq3.png',
];
const DEVICE_KEYS = ['d1','d2','d3','d4','d5','d6'];

export default function CompatibleDevices() {
  const { t } = useTranslation();
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-cyan-500 rounded-full blur-3xl" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-4">
            <span className="text-sm font-medium text-cyan-400">{t('devices.badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-3 text-white">
            {t('devices.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">{t('devices.title2')}</span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base max-w-2xl mx-auto">{t('devices.desc')}</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-5 max-w-5xl mx-auto">
          {DEVICE_KEYS.map((key, i) => (
            <div key={key} className="group bg-gray-900/80 border border-gray-700/50 rounded-2xl p-4 sm:p-5 text-center hover:border-cyan-500/50 hover:scale-105 transition-all duration-300">
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-3 flex items-center justify-center">
                <img src={DEVICE_IMGS[i]} alt={t(`devices.${key}`)} className="w-full h-full object-contain" loading="lazy" />
              </div>
              <h3 className="font-bold text-white text-sm sm:text-base mb-1">{t(`devices.${key}`)}</h3>
              <p className="text-[10px] sm:text-xs text-gray-500">{t(`devices.${key}s`)}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 sm:mt-10 text-center">
          <p className="text-gray-500 text-xs sm:text-sm">{t('devices.note')}</p>
        </div>
      </div>
    </section>
  );
}
